
export default function WhatsAppButton() {
  const phoneNumber = '27844606965'; // WhatsApp format without + or spaces
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer"
      aria-label="Chat on WhatsApp"
    >
      <i className="ri-whatsapp-fill text-white text-3xl"></i>
    </a>
  );
}
